<!--
 * @Author: zql
 * @Date: 2020-03-13 15:29:14
 * @LastEditTime: 2020-06-02 14:34:40
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \enfry-components\packages\components\en-result\src\notfound\not-found.vue
-->
<template>
  <div ref="NotFound" class="notfound">
    <img
      slot="icon"
      class="icon-img"
      src="http://cdn.enfry.com/40411235.png"
      :alt="this.title"
    />
    <div class="title" v-html="title"></div>
    <div class="subtitle" v-html="subTitle"></div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  props: {
    type: { type: String, default: null },
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: "normal"
    },
    title: {
      type: String,
      default: null
    },
    subTitle: {
      type: String,
      default: "哎呀，服务器正在修理，请稍候哦~"
    }
  }
};
</script>
<style lang="scss" scoped>
.notfound {
  text-align: center;
  .icon-img {
    height: 120px;
    width: 320px;
  }
}
</style>
